export const mockedMovimentacaoFundos = [
  {
    id: 111,
    nome_fundo: 'Fundo 001',
    performance_fundo: 'Rentabilidade Últimos 12 Meses',
    disponibilidade_fundo: true
  },
  {
    id: 112,
    nome_fundo: 'Fundo 002',
    performance_fundo: 'Rentabilidade Últimos 12 Meses',
    disponibilidade_fundo: true
  },
  {
    id: 113,
    nome_fundo: 'Fundo 003',
    performance_fundo: 'Rentabilidade Últimos 12 Meses',
    disponibilidade_fundo: true
  },
  {
    id: 114,
    nome_fundo: 'Fundo 004',
    performance_fundo: 'Rentabilidade Últimos 12 Meses',
    disponibilidade_fundo: false
  },
  {
    id: 105,
    nome_fundo: 'Fundo 005',
    performance_fundo: 'Rentabilidade Últimos 12 Meses',
    disponibilidade_fundo: true
  },
  {
    id: 115,
    nome_fundo: 'Fundo 006',
    performance_fundo: 'Rentabilidade Últimos 12 Meses',
    disponibilidade_fundo: true
  },
  {
    id: 117,
    nome_fundo: 'Fundo 007',
    performance_fundo: 'Rentabilidade Últimos 12 Meses',
    disponibilidade_fundo: true
  }
];
